export default __webpack_public_path__ + "static/media/mohsin.f16cc9dc.svg";